import { calcDate } from '@/util/date.js';
import store from '@/store';

export default {
  height: 'auto',
  calcHeight: 30,
  tip: false,
  searchShow: true,
  searchSpan: 6,
  searchMenuSpan: 6,
  border: true,
  index: true,
  viewBtn: false,
  editBtn: false,
  delBtn: false,
  addBtn: false,
  selection: false,
  dialogClickModal: false,
  searchLabelWidth: 100,
  column: [
    {
      label: '主键id',
      prop: 'id',
      type: 'input',
      addDisplay: false,
      editDisplay: false,
      viewDisplay: false,
      hide: true,
    },
    {
      label: '进件编号',
      prop: 'businessCode',
      type: 'input',
      search: true,
      searchOrder: 995,
    },
    {
      label: '所属代理商',
      prop: 'businessDeptName',
      type: 'input',
    },
    {
      label: '产品类型',
      prop: 'rentType',
      type: 'select',
      dicData: store.getters.porductTypes,
    },
    {
      label: '产品类型',
      prop: 'rentTypeList',
      type: 'select',
      hide: true,
      search: true,
      searchOrder: 999,
      searchMultiple: true,
      dicData: store.getters.porductTypes,
    },
    {
      label: '租赁人',
      prop: 'name',
      type: 'input',
      search: true,
      searchOrder: 998,
    },
    {
      label: '手机号',
      prop: 'phoneNumber',
      type: 'input',
    },
    {
      label: '租赁金额',
      prop: 'lendingAmount',
      type: 'input',
    },
    {
      label: '每月租金',
      prop: 'lendingAmountPer',
      type: 'input',
    },
    {
      label: '车牌号',
      prop: 'carFirstNumber',
      type: 'input',
      search: true,
      searchOrder: 997,
    },
    // {
    //   label: '拖车状态',
    //   prop: 'carStatus',
    //   type: 'input',
    // },
    // {
    //   label: '谈判次数',
    //   prop: 'negotiationsCount',
    //   type: 'input',
    //   formatter: (val, value, label) => {
    //     return value ? value + '次' : value;
    //   },
    // },
    {
      label: '逾期天数',
      prop: 'delayDays',
      type: 'input',
      formatter: (val, value, label) => {
        return value ? value + '天' : value;
      },
    },
    {
      label: '滞留时间',
      prop: 'currentTime',
      type: 'input',
      formatter: (val, value, label) => {
        if (!value) return '';
        const date = calcDate(new Date(value).getTime(), new Date().getTime());
        return `${date.days}天${date.hours}小时${date.minutes}分`;
      },
    },
    {
      label: '耗时',
      prop: 'timeConsuming',
      hide: true,
    },
    {
      label: '谈判结果',
      prop: 'returnCat',
      type: 'select',
      hide: true,
      search: false,
      searchOrder: 996,
      dicData: [
        {
          label: '客户违约结清',
          value: 1,
        },
        {
          label: '继续还款',
          value: 2,
        },
      ],
    },
    {
      label: '所属代理商',
      prop: 'businessDeptIdList',
      type: 'select',
      filterable: true,
      addDisplay: false,
      editDisplay: false,
      viewDisplay: false,
      search: true,
      searchMultiple: true,
      searchClearable: true,
      defaultExpandAll: true,
      searchOrder: 1000,
      hide: true,
      dicData: [],
      props: {
        label: 'title',
        value: 'id',
      },
    },
    // {
    //     label: "类型",
    //     prop: "actionSourceTypeList",
    //     type: "select",
    //     hide: true,
    //     showColumn: false,
    //     search: true,
    //     // formatter: (val, value, label) => {
    //     //     // 定义一个映射关系，将数组中的数字映射到对应的字符串
    //     //     const mapping = {
    //     //         1: '逾期未还',
    //     //         2: '合同违约',
    //     //         3: '其他'
    //     //     };
    //     //     // 使用数组的map方法将数字转换为对应的字符串
    //     //     const violationStrings = value.map(violation => mapping[violation]);
    //     //     // 使用join方法将字符串数组组合成一个以短横线分隔的字符串
    //     //     return violationStrings.join('-');
    //     // },
    // },
    // {
    //     label: "类型",
    //     prop: "actionSourceTypeList",
    //     type: "select",
    //     dataType: "number",
    //     dicData: [{
    //             label: "逾期未还",
    //             value: 1
    //         },
    //         {
    //             label: "合同违约",
    //             value: 2
    //         },
    //         {
    //             label: "其他",
    //             value: 3
    //         }
    //     ],
    //     formatter: (val, value, label) => {
    //         // 定义一个映射关系，将数组中的数字映射到对应的字符串
    //         const mapping = {
    //             1: '逾期未还',
    //             2: '合同违约',
    //             3: '其他'
    //         };
    //         // 使用数组的map方法将数字转换为对应的字符串
    //         const violationStrings = value.map(violation => mapping[violation]);
    //         // 使用join方法将字符串数组组合成一个以短横线分隔的字符串
    //         return violationStrings.join('-');
    //     },
    //     value: 0,
    // },
    {
      label: '还租日期',
      prop: 'currentLendingDate',
      type: 'date',
      hide: true,
      searchRange: true,
      searchType: 'daterange',
      valueFormat: 'yyyy-MM-dd',
    },
    {
      label: '车辆状态',
      prop: 'vehicleState',
      hide: true,
      type: 'select',
      dataType: 'number',
      dicData: [
        {
          label: '待售',
          value: 0,
        },
        {
          label: '已售',
          value: 1,
        },
      ],
    },
  ],
};
